import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { McpApiService } from '../mcp-api';
import type {
    WebMcpListResponse,
    WebMcpDetailItem,
    WebMcpEnableData,
    WebMcpListParams,
    WebMcpDetailParams,
} from '../../types';

@injectable()
export class McpApiServiceImpl extends PsHttpService implements McpApiService {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/hub-api/web/mcp`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    getList(params?: WebMcpListParams) {
        return this.get<PatSnapCommonResponseData<WebMcpListResponse>>({
            url: '/list',
            params,
        }).then(res => res.data as WebMcpListResponse);
    }

    getDetail(id: string, params?: WebMcpDetailParams) {
        return this.get<PatSnapCommonResponseData<WebMcpDetailItem>>({
            url: `/by-id/${encodeURIComponent(id)}`,
            params,
        }).then(res => res.data as WebMcpDetailItem);
    }

    enable(id: string) {
        return this.post<PatSnapCommonResponseData<WebMcpEnableData>>({
            url: `/by-id/${encodeURIComponent(id)}/enable`,
        }).then(res => res.data as WebMcpEnableData);
    }

    disable(id: string) {
        return this.post<PatSnapCommonResponseData<WebMcpEnableData>>({
            url: `/by-id/${encodeURIComponent(id)}/disable`,
        }).then(res => res.data as WebMcpEnableData);
    }
}
